
import { defineComponent, computed, PropType, getCurrentInstance } from 'vue'
import { sendLog } from '@/common/radar';
import { Picture } from '~/api/topic';
import { getQuery } from '~/common/utils';

export default defineComponent({
  props: {
    pictureItem: {
      type: Object as PropType<Picture>,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {

    const { proxy }  = getCurrentInstance() || {}
    const origin = window?.location?.origin?? ''

    const jumpLink = computed(() => {
      return `/@${props.pictureItem?.kwai_id}/picture/${props.pictureItem?.pic_id_str}`
    })
    
    const pictureUrl = computed(() => {
      return props?.pictureItem?.pic_thumb_url ?? ''
    })

    const handlePictureClick = () => {
      sendLog({
        type: 'click',
        name: 'PHOTO_TEXT_CARD',
        value: {
          button_type: 'card',
          ...cardCommonParams.value
        }
      })

      const query = getQuery() || {}
      proxy?.$store?.commit('setClickedPicture', props.pictureItem);
      proxy?.$router?.push({ path: jumpLink.value, query: { ...query, page_source: 'topic' } })
    }

    const cardCommonParams = computed(() => {
      return {
        pictrue_id: props?.pictureItem?.pic_id_str ?? '',
        card_position: props.index,
        type: 'picture',
        isMobile: 'true'
      }
    })

    return { 
      pictureUrl, 
      handlePictureClick, 
      cardCommonParams,
      origin,
      jumpLink
    }
  }
})
